import React from 'react'
import {useQuery} from '@apollo/react-hooks'
import gql from 'graphql-tag'
import {Link} from 'react-router-dom'

import {formatDate} from '@prepler/core/lib/constants/dateTime'
import routesHelper from '@prepler/core/lib/routesHelper'

import Loader from '../common/loader'
import GraphqlError from '../dev/graphqlError'
import Markdown from '../common/markdown'
import Helmet from '../common/helmet'
import ArticlesPopular from './popular'
import StickyTitle from '../common/stickyTitle'
import useStyles from './styles'

const ARTICLE = gql`
	query Article($slug: String!) {
		article(slug: $slug) {
			id
			slug
			authorName
			body
			date
			metaDescription
			metaKeywords
			metaTitle
			photo {
				medium
				medium2
				medium4
			}
			title
		}
		articlesPopular(slug: $slug) {
			id
			...ArticlesPopularArticle
		}
	}
	${ArticlesPopular.fragments.article}
`;

const ArticleShow = ({match: {params: {id: articleSlug}}}) => {
	const classes = useStyles();
	const {loading, error, data} = useQuery(ARTICLE, {variables: {slug: articleSlug}, context: {authPublic: true}});

	if (loading) return <Loader/>;
	if (error) return <GraphqlError error={error}/>;

	const {
		article: {id, slug, title, body, date, photo, authorName, metaTitle, metaDescription, metaKeywords},
		articlesPopular
	} = data;

	return (<>{/* <StickyTitle title={<Link to={{pathname: routesHelper.articlesPath()}}>Blog</Link>} titleWrapper="h2"> */}
		<Helmet
			title={metaTitle || title} description={metaDescription} keywords={metaKeywords} image={photo.medium}
			canonical={routesHelper.articleUrl({id: slug || id})}
		/>
		<article className={classes.article}>
			<div className={classes.header}>
				<h1 className={classes.title}>{title}</h1>
				<div className={classes.articleInfo}>
					<time pubdate className={classes.date}>{formatDate(date)}</time>
					{authorName && <span className={classes.author}>by {authorName}</span>}
				</div>
			</div>
			<div className={classes.content}>
				<div className={classes.picture}>
					<img
						alt="" src={photo.medium}
						srcSet={`${photo.medium} 1920w, ${photo.medium2} 960w, ${photo.medium4} 480w`}
					/>
				</div>
				<div className={classes.markdown}>
					<Markdown text={body}/>
				</div>
			</div>
		</article>
		<div className={classes.articleContainer}>
			<div className={classes.relatedInfo}>
				<ArticlesPopular articles={articlesPopular}/>
			</div>
		</div>
	</>);
};

export default ArticleShow;
